import './style.css';

function Informations() {
    return (
        <>
            <div id="informations">
                <div id="information-container">
                    <h1>CHARTES</h1>
                    <br/>
                    <br/>
                    <p>En vous inscrivant au groupe Phoenix, les parents et les enfants reconnaissent avoir pris connaissance de la charte des parents et de la charte de jeunes et s’engagent à les respecter.</p>
                    <br/>
                    <br/>
                    <h2>Charte des parents</h2>
                    <br/>
                    <p>En inscrivant votre enfant dans le groupe Phoenix, vous adhérez à un esprit convivial, bienveillant et respectueux, garant du bon fonctionnement collectif.</p>
                    <br/>
                    <br/>
                    <h2>1. Engagement des parents</h2>
                    <br/>
                    <ul>
                        <li>Chaque famille s’engage à accueillir le groupe au moins une fois pour une activité, un cours de danse ou une soirée.</li>
                        <li>Les activités peuvent s’organiser à 2 familles et les soirées à 3 familles.</li>
                        <li>Nous vous demandons d’être attentifs à ce que vos enfants prennent le temps de répondre aux invitations et de remercier leurs hôtes.</li>
                        <li>Les parents hôtes doivent être présents pendant toute l’activité, afin d’en assurer le bon déroulement, la sécurité et la bonne ambiance.</li>
                    </ul>
                    <br/>
                    <br/>
                    <h2>2. Alcool</h2>
                    <br/>
                    <p>Aucun alcool ne sera proposé durant les deux premières années (2026–2028). Lorsqu’il sera proposé lors d’un cours de danse ou d'une soirée, il sera servi avec modération et en accord avec la réglementation belge.</p>
                    <br/>
                    <br/>
                    <h2>3. Confidentialité et communication</h2>
                    <br/>
                    <p>Aucune publication ne peut être faite sur les réseaux sociaux, dans la presse ou sur Internet sans l’accord préalable des parents concernés et du comité. Les coordonnées et données personnelles des familles et des jeunes sont strictement réservées à un usage interne (RGPD).</p>
                    <br/>
                    <br/>
                    <h2>4. Assurance et responsabilité</h2>
                    <br/>
                    <p>Les parents et les jeunes dégagent les organisateurs bénévoles de toute responsabilité liée aux activités ou aux transports. Les parents autorisent les courts trajets en voiture effectués par les organisateurs ou par un tiers de confiance.</p>
                    <br/>
                    <p>En cas d’urgence, vous autorisez les organisateurs à prendre toute décision nécessaire, y compris d’ordre médical. Les parents déclarent disposer d’une assurance responsabilité civile familiale couvrant leur enfant.</p>
                    <br/>
                    <br/>
                    <h2>CHARTE DES JEUNES</h2>
                    <br/>
                    <p>Voici les valeurs qui nous paraissent être les ingrédients de base du plaisir d’être ensemble : convivialité, gentillesse, amitié, enthousiasme ainsi que le respect des autres et des lieux.</p>
                    <br/>
                    <ul>
                        <li>Ma présence régulière aux activités favorise mon intégration.</li>
                        <li>Je réponds aux invitations dans les délais impartis et de manière respectueuse.</li>
                        <li>J’arrive à l’heure, dans une tenue correcte et appropriée, et je reste jusqu’à la fin de l’activité.</li>
                        <li>Je n’oublie pas de saluer les hôtes à mon arrivée et de les remercier avant mon départ.</li>
                        <li>J’adopte une conduite exemplaire en toute circonstance envers les hôtes et les autres membres.</li>
                        <li>Je ne diffuse pas de photos de personnes sans leur demander leur autorisation.</li>
                        <li>L’apport d’alcool sur les lieux de l’activité est strictement interdit.</li>
                        <li>La consommation ou la détention de drogue entraînera une exclusion immédiate.</li>
                        <li>Les cigarettes, cigarettes électroniques et puffs ne sont pas autorisées.</li>
                    </ul>
                    <br/>
                    <p>En rejoignant le groupe « Phoenix », je m’engage à respecter ces principes et à adhérer pleinement à cet esprit.</p>
                </div>
            </div>
        </>
    );
}

export default Informations;